import { useRouter } from 'next/router';
import { memo } from 'react';

import { Button } from 'components/@tedui';
import { useLocalStorage } from 'lib/hooks/useLocalStorage';

import { useInstantSearch } from 'react-instantsearch';
import { useModalStore } from '../../../Modals';
import { useTrackClickEvent } from '../../../analytics';

function ClearRefinements(): React.ReactNode {
  const router = useRouter();
  const { resetSelectedTopics } = useModalStore();
  const { results } = useInstantSearch();
  const trackClick = useTrackClickEvent(
    results
      ? {
          index: results.index,
          nbHits: results.nbHits
        }
      : undefined
  );
  const [, setCategoryContext] = useLocalStorage('category', null);
  const [, setTopicLaunchPadContext] = useLocalStorage('topic_launchpad', null);

  const clearSearch = () => {
    router.push('/talks');
    resetSelectedTopics();
    setCategoryContext(null);
    setTopicLaunchPadContext(null);
    trackClick({
      eventName: 'clear_search'
    });
  };

  return (
    <Button
      onClick={clearSearch}
      variant="inline"
      isFullWidth={false}
      text="Clear search"
    />
  );
}

export default memo(ClearRefinements);
